import {
  Box,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import React, { memo, useEffect, useMemo, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useTaxCertificate } from 'src/hooks/tax-certificate/use-tax-certificate';
import {
  GetTaxCertificateListPayload,
  TaxCertificateData
} from 'src/redux/slices/purchase-order/tax-certificate/types';
import { AlternatingColorTableRow, LinkComponent } from 'src/components';
import { Pagination } from '@material-ui/lab';
import useResolution from 'src/hooks/useResolution';
import { useNavigate } from 'react-router';

const useStyles = makeStyles(() => ({
  table: {
    border: '1px solid #a4abba',
    minWidth: '1050px'
  }
}));

const Component = () => {
  const classes = useStyles();
  const { isMobile } = useResolution();
  const navigate = useNavigate();
  const [page, setPage] = useState<number>(1);
  const {
    taxCertificateListColumn,
    taxCertificateList,
    taxCertificateListParams,
    setTaxCertificateListParams,
    fetchTaxCertificateList,
    taxCertificateListMeta
  } = useTaxCertificate();

  const taxCertificateListHeader = useMemo(() => {
    return taxCertificateListColumn;
  }, [taxCertificateListColumn]);

  const onHandleChangePage = (
    page: number,
    params: GetTaxCertificateListPayload
  ) => {
    setTaxCertificateListParams({ ...params, page });
    fetchTaxCertificateList({ ...params, page });
    setPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    setPage(taxCertificateListParams?.page || 1);
  }, [taxCertificateListParams]);

  return (
    <PerfectScrollbar>
      <Table className={classes.table} stickyHeader>
        <TableHead>
          <TableRow>
            {taxCertificateListHeader?.map((header, index) => (
              <TableCell key={index}>{header?.name}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {taxCertificateList?.map((item: TaxCertificateData) => (
            <AlternatingColorTableRow key={item.tax_certificate_id}>
              {taxCertificateListHeader?.map((header) => {
                const key = header.value;
                return (
                  <TableCell
                    key={key}
                    onClick={() =>
                      navigate(
                        `/app/tax-certification/${item.tax_certificate_id}`
                      )
                    }
                    style={{ cursor: 'pointer' }}
                  >
                    {key == 'id' && (
                      <LinkComponent
                        href={`/app/tax-certification/${item.tax_certificate_id}`}
                        title={`${item?.tax_certificate_id}`}
                      />
                    )}
                    {key == 'supplier_name' && item?.supplier_name}
                    {key == 'period_from' && item?.period_from}
                    {key == 'period_to' && item?.period_to}
                    {key == 'created_at' && item?.created_at}
                  </TableCell>
                );
              })}
            </AlternatingColorTableRow>
          ))}
        </TableBody>
      </Table>
      <Box
        sx={{
          display: 'flex',
          justifyContent: isMobile ? 'center' : 'end',
          alignContent: 'center',
          width: '100%',
          mt: 3
        }}
      >
        <Pagination
          count={taxCertificateListMeta?.last_page}
          page={page || taxCertificateListMeta?.current_page}
          onChange={(e: any, p: number) =>
            onHandleChangePage(p, taxCertificateListParams)
          }
        />
      </Box>
    </PerfectScrollbar>
  );
};

export const TaxCertificateTable = memo(Component);
